.menuItem {
  --md-menu-item-container-color: var(--pgm-sys-color-surface-container-low);
  --md-menu-item-label-text-color: var(--pgm-sys-color-on-surface);
  --md-menu-item-leading-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-menu-item-trailing-icon-color: var(--pgm-sys-color-on-surface-variant);
  --md-menu-item-selected-container-color: var(--pgm-sys-color-secondary-container);
  --md-menu-item-selected-label-text-color: var(--pgm-sys-color-on-secondary-container);
  --md-menu-item-hover-state-layer-color: var(--pgm-sys-color-on-surface);
  --md-menu-item-hover-state-layer-opacity: 0.08;
  --md-menu-item-pressed-state-layer-color: var(--pgm-sys-color-on-surface);
  --md-menu-item-disabled-opacity: 0.38;
  --md-menu-item-one-line-container-height: 48px;
  --md-menu-item-top-space: 0;
  --md-menu-item-bottom-space: 0;
  --md-menu-item-leading-space: 14px;
  --md-menu-item-trailing-space: 14px;

  align-items: center;
  border-radius: 0;
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  height: 48px;
  margin-inline: 4px;
  width: calc(var(--pgm-vertical-menu-width, 240px) - 8px);
}

.menuItem:hover:not([disabled]),
.menuItem:focus-within:not([disabled]) {
  border-radius: 4px;
}

.menuItem[selected] {
  --md-menu-item-selected-container-color: var(--pgm-sys-color-secondary-container);
  --md-menu-item-selected-label-text-color: var(--pgm-sys-color-on-secondary-container);
  --md-menu-item-leading-icon-color: var(--pgm-sys-color-on-secondary-container);
  --md-menu-item-trailing-icon-color: var(--pgm-sys-color-on-secondary-container);
  border-radius: 4px;
}

.menuItem:first-child:hover:not([disabled]),
.menuItem:first-child:focus-within:not([disabled]),
.menuItem:first-child[selected] {
  border-radius: 12px 12px 4px 4px;
}

.menuItem:last-child:hover:not([disabled]),
.menuItem:last-child:focus-within:not([disabled]),
.menuItem:last-child[selected] {
  border-radius: 4px 4px 12px 12px;
}

.menuItemLabel {
  align-self: stretch;
  align-items: center;
  display: flex;
}

.menuItemIcon {
  color: inherit;
  flex: 0 0 24px;
  height: 24px;
  width: 24px;
}
